import React, { useState } from "react";
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import { Accordion, AccordionSummary, AccordionDetails, } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { DelReqContentWrapper } from "./orderTabsStyled";
import * as moment from "moment";
import AlertModal from 'web/components/AlertModal';
import ConfirmationModal from "web/components/ConfirmationModal";
import { deliveryReqOrderDeclineApi } from "redux/actions/myPickupOrders"

const DeliveryRequestsListDetails = (props) => {
  const dispatch = useDispatch();
  let history = useHistory()
  const { pageData } = props
  const [tempStoreDeclineId, setTempStoreDeclineId] = useState();
  const [modal, setModal] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [modalContent, setModalContent] = useState('');
  const [confirmationComment, setConfirmationComment] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);
  const [yesNoModalContent, setYesNoModalContent] = useState("");

  const declinePickupOrderFunc = (data) => {
    setYesNoModalContent("Please provide a reason for declining this load request.");
    setTempStoreDeclineId(data?.tenderId);
    setYesNoModal(true);
  }

  const declinePickupOrderConfirmation = async () => {
    let response;
    setYesNoModal(!yesNomodal)
    const token = localStorage.getItem('token');
    let data = {
      locationId: localStorage.getItem('locationId'),
      tenderId: tempStoreDeclineId,
      comment: confirmationComment ?? null,
      tenderStatus: 'REJECTED'
    }
    response = await dispatch(deliveryReqOrderDeclineApi(data, token));
    if (response?.success) {
      setAlertType('tenderDeclineSuccess');
      setModalContent(response?.data?.msg);
      setModal(true);
    } else {
      setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
      setModal(true);
    }
  }

  const pickupOrderCheckoutRedirect = (data) => {
    let obj = {
      id: data?.tenderId?.toString(),
      type: 'sellerDeliveryRequestOrderCheckout'
    }
    dispatch({ type: 'CHECKOUT', payload: obj });
    history.push({ pathname: '/checkout' });
  }

  const formOrderDetailsString = items => {
    let details = [];

    if (items?.palletDetails?.material) {
      details.push(items.palletDetails.material);
    }
    if (items?.palletDetails?.condition?.length) {
      let condition = items.palletDetails.condition.join(', ');

      if (items?.palletDetails?.newConditionType === 'HARDWOOD') {
        condition += ' (HW)';
      } else if (items?.palletDetails?.newConditionType === 'SOFTWOOD') {
        condition += ' (SW)';
      }

      details.push(condition);
    }
    if (items?.palletDetails?.palletType) {
      details.push(items.palletDetails.palletType);
    }
    if (items?.palletDetails?.moisture) {
      details.push(items.palletDetails.moisture);
    }
    if (items?.palletDetails?.size && items.palletDetails.size !== 'Custom') {
      details.push(items.palletDetails.size);
    }
    if (items?.palletDetails?.size === 'Custom') {
      details.push('Custom');
    }
    if (items?.palletDetails?.height) {
      let dimension = `${items.palletDetails.length}x${items.palletDetails.width}x${items.palletDetails.height}`;
      details.push(dimension);
    }
    if (items?.palletDetails?.grade) {
      details.push(items.palletDetails.grade);
    }
    return details.join(', ');
  }

  return (
    <>
      <DelReqContentWrapper>
        <div style={{ marginBottom: '20px', padding: '0 10px', gap: '20px', display: 'flex', flexDirection: 'column' }}>
          {pageData?.map(data => (
            <>
              <div key={data.orderRefNumber} className="pending-tab-content-web-view">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <div className="pending-tab-content-web-view-wrapper">
                      <p className='loc-name-style' title={data.address?.locationName}>{data.address?.locationName}</p>
                      <p>{data.poNumber}</p>
                      <p>{`(${data.address?.city}, ${data.address?.stateAbv})`}</p>
                      <p style={{ flex: 0.5 }}>{data.quantity}</p>
                      <p style={{ color: '#0a5587' }}>{moment(data.requestedDate).format('MM/DD/YYYY')}</p>
                      <p className="button-wrapper">
                        <button className="accept" onClick={() => pickupOrderCheckoutRedirect(data)}>Accept</button>
                        <button className="reject" onClick={() => declinePickupOrderFunc(data)}>Decline</button>
                      </p>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="accordion-details-style">
                      <div className="div-wrapper"><p style={{ color: '#28a745' }}>Buyer Name:</p><span style={{ color: '#28a745' }}>{data?.buyerLocationName}</span></div>
                      <div className="div-wrapper"><p>Order Type:</p><span>{formOrderDetailsString(data)}</span></div>
                      <div className="div-wrapper"><p>Order Quantity:</p><span>{data.quantity}</span></div>
                      <div className="div-wrapper"><p>Unit Price:</p><span>$ {data?.price?.toFixed(2)}</span></div>
                      <div className="div-wrapper"><p>Requested Delivery:</p><span>{moment(data.requestedDate).format('MM/DD/YYYY')} {data.startTime}-{data.endTime}</span></div>
                      <div className="div-wrapper"><p>Delivery Address:</p>
                        <div>
                          <div style={{ fontFamily: 'latobold' }}>{data.address?.locationName}</div>
                          <div>{data.address?.address1}{data.address?.address2 ? `, ${data.address?.address1}` : ''}</div>
                          <div>{data.address?.city}, {data.address?.stateAbv} {data.address?.zipCode}</div>
                        </div>
                      </div>
                      <div className="div-wrapper"><p>Load Comments:</p><span>{data?.buyerComment}</span></div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div key={data.orderRefNumber} className="pending-tab-content-mobile-view">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <div className="pending-tab-content-mobile-view-wrapper">
                      <div className="outer-wrapper">
                        <div className="row-class">
                          <div className="elements-class">
                            <h6>Location Name</h6>
                            <p title={data.address?.locationName}>{data.address?.locationName}</p>
                          </div>
                          <div className="elements-class">
                            <h6>PO Number</h6>
                            <p title={data.poNumber}>{data.poNumber}</p>
                          </div>
                        </div>
                        <div className="row-class">
                          <div className="elements-class">
                            <h6>Quantity</h6>
                            <p title={data.quantity}>{data.quantity}</p>
                          </div>
                          <div className="elements-class">
                            <h6>Req. Date</h6>
                            <p>{moment(data.requestedDate).format('MM/DD/YYYY')}</p>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="button-wrapper">
                        <button className="accept" onClick={() => pickupOrderCheckoutRedirect(data)}>Accept</button>
                        <button className="reject" onClick={() => declinePickupOrderFunc(data)}>Decline</button>
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="accordion-details-style">
                      <div className="div-wrapper"><p style={{ color: '#28a745' }}>Buyer Name:</p><span style={{ color: '#28a745' }}>{data?.buyerLocationName}</span></div>
                      <div className="div-wrapper"><p>Order Type:</p><span>{formOrderDetailsString(data)}</span></div>
                      <div className="div-wrapper"><p>Order Quantity:</p><span>{data.quantity}</span></div>
                      <div className="div-wrapper"><p>Unit Price:</p><span>$ {data?.price?.toFixed(2)}</span></div>
                      <div className="div-wrapper"><p>Requested Delivery:</p><span>{moment(data.requestedDate).format('MM/DD/YYYY')} {data.startTime}-{data.endTime}</span></div>
                      <div className="div-wrapper"><p>Delivery Address:</p>
                        <div>
                          <div style={{ fontFamily: 'latobold' }}>{data.address?.locationName}</div>
                          <div>{data.address?.address1}{data.address?.address2 ? `, ${data.address?.address1}` : ''}</div>
                          <div>{data.address?.city}, {data.address?.stateAbv} {data.address?.zipCode}</div>
                        </div>
                      </div>
                      <div className="div-wrapper"><p>Buyer Comment:</p><span>{data?.buyerComment}</span></div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </>
          ))}
        </div>
        {pageData?.length === 0 && <p style={{ textAlign: 'center' }}>No records found</p>}
      </DelReqContentWrapper>
      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        title=""
        content={modalContent}
        link={''}
        alertType={'success'}
        callBackAlert={() => {
          if (alertType === 'tenderDeclineSuccess') {
            props.fetchDataCallBack('decline'); //refresh with updated records
          }
        }}
      />
      <ConfirmationModal
        isOpen={yesNomodal}
        toggle={() => {
          setYesNoModal(!yesNomodal);
          setConfirmationComment("");
        }}
        onClickHander={(val) => {
          if (val === "no") {
          } else declinePickupOrderConfirmation()
        }}
        content={yesNoModalContent}
        confirmationComment={confirmationComment}
        setconfirmationComment={setConfirmationComment}
      />
    </>
  )
}

export default DeliveryRequestsListDetails;
